import { useContext, useState } from "react";
import userContext from "./Context";

function Create() {

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const { users, setUsers } = useContext(userContext);

  function handleSubmit(e) {
    e.preventDefault();

    if (!name || !email || !password) {
      alert("Please fill all fields");
      return;
    }

    const newUser = {
      name: name,
      email: email,
      password: password,
      amount: 0
    };

    setUsers([...users, newUser]);

    alert("Account Created Successfully ✅");

    setName("");
    setEmail("");
    setPassword("");
  }

  return (
    <>
      <div className="d-flex justify-content-center align-items-center bg-secondary vh-100">
        <div className="bg-white p-3 rounded w-25">
          <h2 className="text-center mb-3">Create</h2>

          <form onSubmit={handleSubmit}>

            <div className="mb-3">
              <label><strong>Name</strong></label>
              <input
                type="text"
                className="form-control rounded-pill"
                value={name}
                onChange={(e)=>setName(e.target.value)}
              />
            </div>

            <div className="mb-3">
              <label><strong>Email</strong></label>
              <input
                type="email"
                className="form-control rounded-pill"
                value={email}
                onChange={(e)=>setEmail(e.target.value)}
              />
            </div>

            <div className="mb-3">
              <label><strong>Password</strong></label>
              <input
                type="password"
                className="form-control rounded-pill"
                value={password}
                onChange={(e)=>setPassword(e.target.value)}
              />
            </div>

            <button type="submit" className="btn btn-primary w-100 rounded-pill">
              Submit
            </button>

          </form>
        </div>
      </div>
    </>
  );
}

export default Create;

